<template>
    <v-layout class="data-collection-layout">
        <v-flex>
            <data-collection
                v-if="formConfig && item"
                :data.sync="item"
                :app-data="{}"
                :form-config="formConfig"
                :config-version-number="configVersionNumber"
                :vuetify-breakpoint="$vuetify.breakpoint"
                :is-submitting="isSubmitting"
                @update-form="createDataCollection"
            />
            <error-modal :show="errorModal" :error-key="errorKey" @close="closeAndRedirectToCoupon" />
        </v-flex>
    </v-layout>
</template>

<script>
import { cloneDeep, get, includes, reduce } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import Store from '@/store';
import { dataCollection, registerModule, mergeLocales } from '@trimoz/forms-library';
import { errorHandlingMixin, TrimozError } from '@trimoz/trimoz-vue-error-handling';
import { FormRoleId, FormStatusCustom } from '@/enums';
import ErrorModal from '@/components/ErrorModal';
import { analyticsEventHandler } from '@/mixins/ga-event-handler';

export default {
    components: {
        dataCollection,
        ErrorModal
    },
    data() {
        return {
            formConfig: null,
            saveLoading: false,
            errorModal: false,
            errorKey: null,
            isSubmitting: false,
            configVersionNumber: null
        };
    },
    mixins: [errorHandlingMixin, analyticsEventHandler],
    async created() {
        // Register global data vuex store & merge i18n text
        if (!Store.hasModule('globalData')) {
            registerModule(Store);
            mergeLocales(this.$i18n);
        }

        await this.getFormListByEstablishment({ establishmentId: this.getFirstAppointment.establishment });

        await this.getFormById({ formId: this.getServiceHasDataCollectionFormId });
        this.item = cloneDeep(this.getData);
        this.formConfig = this.getConfig;
        this.configVersionNumber = this.getConfigVersionNumber;
    },
    computed: {
        ...mapGetters({
            getConfig: 'forms/getConfig',
            getData: 'forms/getData',
            getConfigVersionNumber: 'forms/getConfigVersionNumber',
            getFirstAppointment: 'appointments/getFirstAppointment',
            getServiceHasDataCollectionFormId: 'services/getServiceHasDataCollectionFormId',
        }),
    },
    methods: {
        ...mapActions({
            createFormFromPublic: 'forms/createFormFromPublic',
            getFormListByEstablishment: 'forms/getFormListByEstablishment',
            getFormById: 'forms/getFormById'
        }),

        async submitForm() {
            try {
                this.saveLoading = true;
                await this.createFormFromPublic(this.item);
                this.publicIsDataCollectionFormCompletedAnalytics();
                this.$emit('closeForm', this.item);
            }
            catch (error) {
                throw new TrimozError(error, 'base.errors.failed');
            }
            finally {
                this.saveLoading = false;
            }
        },

        async createDataCollection() {
            try {
                if (!this.isSubmitting) {
                    this.isSubmitting = true;
                    const { establishment, id, formToken } = this.getFirstAppointment;
                    this.item = {
                        status: FormStatusCustom.COMPLETE,
                        establishmentId: establishment,
                        appointmentId: id,
                        token: formToken,
                        modifiedBy: FormRoleId.PUBLIC,
                        data: reduce(this.item, (data, currData) => {
                            return { ...data, [currData.name]: currData.value };
                        }, {}),
                        deleteAfter: null
                    };
                    await this.submitForm();
                }
            }
            catch (error) {
                const errorInternalCode = get(error, 'inner.internalCode', null);
                if(includes(['forbidden.action'], errorInternalCode)) {
                    this.errorKey = 'errors.forms.expiredToken';
                    this.errorModal = true;
                    this.publicIsDataCollectionFormTokenTimeout();
                }
                else {
                    throw new TrimozError(error, 'errors.generic');
                }
            }
        },
        closeAndRedirectToCoupon() {
            this.errorModal = false;
            this.$emit('closeForm', this.item);
        },
    },
};
</script>
